// extracted by css-extract-rspack-plugin
export default {"text":"text-Xv1MAy"};